export default "__VITE_ASSET__B_6rfnSr__"